import React from "react";

import { HighlightRect } from "./hooks/useOcrHighlights";

type OcrHighlightOverlayProps = {
  /** Highlight rectangles for this page, normalized 0-1 to the page box. */
  rects: HighlightRect[];
  /** Ref set on the first rect so the caller can scroll it into view. */
  firstRectRef?: React.Ref<HTMLDivElement>;
};

/**
 * Draws translucent highlight rectangles over the OCR-matched source lines of a
 * scanned PDF page (MDRS-134). Rendered as an absolutely-positioned sibling of
 * `<Page>` inside its `relative` wrapper; positions are percentages of the page
 * box so they stay correct across zoom. Sits below the snip overlay (z-0) and
 * is non-interactive so it never blocks text selection or snipping.
 */
export const OcrHighlightOverlay: React.FC<OcrHighlightOverlayProps> = ({
  rects,
  firstRectRef,
}) => {
  if (rects.length === 0) return null;

  return (
    <div className="pointer-events-none absolute inset-0 z-0">
      {rects.map((r, i) => (
        <div
          key={i}
          ref={i === 0 ? firstRectRef : undefined}
          className="absolute rounded-[2px] bg-amber-400/40 mix-blend-multiply"
          style={{
            left: `${r.x * 100}%`,
            top: `${r.y * 100}%`,
            width: `${r.width * 100}%`,
            height: `${r.height * 100}%`,
          }}
        />
      ))}
    </div>
  );
};
